module.exports = __webpack_public_path__ + "static/media/tick.84f54e41.svg";